import {BaseFilterModel} from "./baseFilter.model";

/**
 * Модель поиска для раздела "Недействительные паспорта"
 */
export class PassportInfoFilterModel extends BaseFilterModel {
  series = ''; // Серия
  number = ''; // Номер
}
